import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryConfig } from 'store/baseQueryConfig '

// packApi contains all the endpoints related to pack operations
export const packApi = createApi({
  reducerPath: 'packApi',
  baseQuery: baseQueryConfig,
  tagTypes: ['PACK'],
  endpoints: (builder) => ({
    getPacks: builder.query({
      query: () => ({
        url: 'pack',
        method: 'GET',
      }),
      providesTags: ['PACK'],
    }),
  }),
})

// Export hooks
export const { useGetPacksQuery } = packApi
export default packApi
